import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../components/intern/Sidebar/Sidebar";
import { checkAuth } from "../../store/actions/authActions";
import { fetchUserAuthById } from "../../store/actions/userAuthActions";
import { UserProvider } from "../../context/UserContext"; 
import './PrivateRouter.css';

import LoadingScreenPage from '../../pages/general/LoadingScreenPage/LoadingScreenPage'

const PrivateRouter = ({ children }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const userAuth = useSelector((state) => state.userAuth);
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();

useEffect(() => {
  const verifyUser = async () => {
    try {
      const result = await dispatch(checkAuth()).unwrap(); // unwrap retorna o payload
      const userId = result.user?.uid; // pega o id retornado
      
      if (userId) {
        await dispatch(fetchUserAuthById(userId));
      }
    } catch (error) {
      console.error("Erro ao verificar autenticação:", error);
    } finally {
      setLoading(false);
      }
  };

  verifyUser();
}, [dispatch]);


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  if (loading) {
    return <LoadingScreenPage />;
  }
  if (!auth.isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (!userAuth?.userAuth?.approved) {
    return <Navigate 
            to="/" 
            state={{ message: "Usuário necessita de aprovação" }} 
          />;
  }


  return (
    <UserProvider user={{ authUser: auth.user, userDb: userAuth.userAuth }}>
      <div className={`content-with-sidebar ${isSidebarOpen ? 'open-sidebar' : 'closed-sidebar'}`}>
        <Sidebar
          activePage={location.pathname}
          user={auth.user}
          userDb={userAuth.userAuth}
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />
        <main className="main-content">
          {children}
        </main>
      </div>
    </UserProvider>
  );
};

export default PrivateRouter;
